export default {
  'nav.poti': 'Staze',
  'nav.izhodisca': 'Polazišta',
  'nav.galerija': 'Galerija',
  'nav.vreme': 'Vrijeme',
  'nav.o_nas': 'O nama',
  'nav.zacni_pot': 'Započni stazu',
  'nav.odpri_meni': 'Otvori izbornik',
  'nav.zapri_meni': 'Zatvori izbornik',
  'nav.preskoci': 'Preskoči na sadržaj',

  'hero.badge': 'Turističko društvo STEZA — Šmarna gora',
  'hero.title': 'POT NA PESKE',
  'hero.subtitle': 'ŠMARNA GORA',
  'hero.desc': 'Jedna od najljepših, najraznolikijih i najugodnijih staza za posjetitelje svih generacija.',
  'hero.cta_start': 'Započni stazu',
  'hero.cta_explore': 'Istraži staze',
  'hero.cta_activities': 'Aktivnosti',
  'hero.scroll': 'Pomakni se',

  'intro.badge': 'Dobrodošli',
  'intro.title': 'Šmarna gora, najomiljeniji ljubljanski brežuljak',
  'intro.desc': 'Šmarna gora, najpopularniji brežuljak kraj Ljubljane, nudi brojne staze za planinare, trkače i ljubitelje prirode.',
  'intro.highlight': 'Staza Peske smatra se jednom od najljepših, najraznolikijih i najugodnijih staza za posjetitelje svih dobi.',
  'intro.pot_label': 'Staza Peske',
  'intro.route': 'Spodnje Pirniče → Šmarna gora',

  'activities.badge': 'Aktivnosti',
  'activities.title': 'ISTRAŽIVANJE ŠMARNE GORE',
  'activities.hiking.title': 'Planinarenje na Šmarnu goru',
  'activities.hiking.desc': 'Otkrijte različite staze, od laganih šetnji do zahtjevnijih uspona.',
  'activities.cycling.title': 'Biciklizam oko Šmarne gore',
  'activities.cycling.desc': 'Istražite slikovite biciklističke rute u okolici s prekrasnim pogledima.',
  'activities.running.title': 'Trail trčanje na Šmarnoj gori',
  'activities.running.desc': 'Popularna destinacija za trail trkače — raznolik teren s idealnim nagibom.',
  'activities.running_around.title': 'Trčanje oko Šmarne gore',
  'activities.running_around.desc': 'Ravne i blage trkačke staze u podnožju, idealne za rekreativni trening.',
  'activities.walks.title': 'Šetnje podno Šmarne gore',
  'activities.walks.desc': 'Mirne šetnje livadama i šumskim stazama, idealne za obitelji.',

  'access.badge': 'Polazište',
  'access.title': 'POLAZIŠTE I PRISTUP',
  'access.desc': 'Staza počinje kod parkirališta LIPA u Spodnjim Pirničama. Pristup je jednostavan — automobilom ili autobusom.',
  'access.start_label': 'Polazište staze',
  'access.address': 'Spodnje Pirniče 56',
  'access.parking_name': 'Parkiralište LIPA',
  'access.parking': 'Parkiralište',
  'access.free': 'Besplatno',
  'access.bus': 'Autobus',
  'access.bus_line': 'Linija 25',
  'access.info1': 'Parkirajte vozilo na parkiralištu LIPA ili dođite autobusom broj 25 izravno na polazište ispred ugostiteljskog objekta s prekrasnom terasom, gdje možete uživati u osvježavajućem piću ili zalogaju prije početka staze.',
  'access.info2': 'Na početku, uska staza posuta drvenom sječkom vodi vas pokraj livade prema šumi, gdje počinje uspon.',

  // ── PARKING ──
  'parking.hero_title': 'Parkiralište LIPA — Službeno polazište',
  'parking.hero_subtitle': 'Spodnje Pirniče 56, 1211 Ljubljana-Šmartno. Besplatno parkiralište odmah na početku staze Pot na Peske.',
  'parking.highlight_badge': '⭐ Službeno polazište',
  'parking.section_title': 'PARKIRANJE & PRISTUP',
  'parking.intro': 'Parkiralište LIPA je službeno, besplatno i najprikladnije polazište za Pot na Peske — našu najljepšu stazu na Šmarnu goru.',
  'parking.address_label': 'Adresa',
  'parking.address_value': 'Spodnje Pirniče 56, 1211 Ljubljana-Šmartno, Slovenija',
  'parking.gps_label': 'GPS Koordinate',
  'parking.gps_value': '46.1176° N, 14.4544° E',
  'parking.what3words': 'what3words',
  'parking.what3words_value': '///vzpon.pesek.lipa',
  'parking.capacity_label': 'Kapacitet',
  'parking.capacity_value': 'Besplatno, mjesta za 20+ vozila',
  'parking.type_label': 'Tip parkirališta',
  'parking.type_value': 'Otvoreno makadamsko parkiralište',
  'parking.hours_label': 'Otvoreno',
  'parking.hours_value': '24/7 — sve dane u godini',
  'parking.bus_info_title': 'Javni prijevoz',
  'parking.bus_info': 'Autobus LPP linija 25 vozi izravno do stajališta ispred parkirališta. Vožnja iz centra Ljubljane traje oko 30 minuta.',
  'parking.facilities_title': 'Infrastruktura',
  'parking.facility_gostilna': 'Restoran s prekrasnom terasom odmah uz parkiralište',
  'parking.facility_wc': 'WC dostupan u restoranu',
  'parking.facility_info': 'Informativna tabla na početku staze Pot na Peske',
  'parking.facility_sign': 'Putokaz STEZA / Pot na Peske',
  'parking.tips_title': 'Korisni savjeti za parkiranje',
  'parking.tip1': 'Vikendom i praznicima parkiralište se brzo popuni — dođite rano (prije 8 sati).',
  'parking.tip2': 'Parkiralište je makadamsko — zimi pazite na moguću poledicu.',
  'parking.tip3': 'Ne ostavljajte vrijedne predmete u automobilu. Parkirate na vlastitu odgovornost.',
  'parking.tip4': 'Dodatno parkiralište dostupno kod Gostilne Ledinek u Tacnu (5 min vožnje) ako je LIPA puno.',
  'parking.map_title': 'Lokacija na karti',
  'parking.cta_title': 'Spremni za Pot na Peske?',
  'parking.cta_subtitle': 'Parkirajte na LIPA i krenite najljepšom stazom na Šmarnu goru.',
  'parking.cta_btn': 'Započni stazu',
  'parking.cta_routes': 'Sve staze',

  'story.badge': 'Staza Peske',
  'story.title': 'OD POLAZIŠTA DO VRHA',
  'story.subtitle': 'Kinematografsko putovanje kroz svaku etapu staze',
  'story.etapa': 'Etapa',
  'story.blocks.0.title': 'Blagi početak',
  'story.blocks.0.text': 'Isprva se blago uspinjemo udobnom, širokom stazom, djelomično prekrivenom stijenama i korijenjem. Ubrzo skrećemo na sve užu stazu koja se nešto strmije penje.',
  'story.blocks.0.terrain': 'Široka staza, stijene, korijenje',
  'story.blocks.1.title': 'Najraznolikiji dio',
  'story.blocks.1.text': 'Hodamo sve pjeskovitijim tlom, po stijenama i korijenju, djelomično kroz relativno dubok žlijeb. Ovo je najstrmiji, ali i najraznovrsniji dio staze.',
  'story.blocks.1.terrain': 'Pjeskovito tlo, stijene, žlijeb',
  'story.blocks.2.title': 'Makadamska cesta',
  'story.blocks.2.text': 'Kad se staza proširi i izravna, ubrzo smo na širokoj makadamskoj cesti, voznom putu na Šmarnu goru koji dolazi iz Zavrha.',
  'story.blocks.2.terrain': 'Makadam, široka staza',
  'story.blocks.3.title': 'Tursko znamenje',
  'story.blocks.3.text': 'Ovdje nas planinarska tabla usmjerava desno, pokraj kužnog odnosno Turskog znamenja, koje podsjeća na vrijeme turskih provala.',
  'story.blocks.3.terrain': 'Planinarska tabla, povijesna točka',
  'story.blocks.4.title': 'Gorjančeva kapelica',
  'story.blocks.4.text': 'Cesta se umjereno uspinje kroz šumu koja se s vremenom otvara. S lijeve strane je Gorjančeva kapelica, gdje je očuvan običaj odlaganja malih križeva.',
  'story.blocks.4.terrain': 'Šumska cesta, kapelica',
  'story.blocks.5.title': 'Spodnji Gorjanc — raskrižje',
  'story.blocks.5.text': 'Dolazimo do Spodnjeg Gorjanca, važnog raskrižja više staza. Ovdje se križaju smjerovi prema Grmadi, Staza korijenja (prema Tacnu) i nastavak prema Šmarnoj gori.',
  'story.blocks.5.terrain': 'Raskrižje staza, Grmada, Staza korijenja',
  'story.blocks.6.title': 'Pogled na Alpe',
  'story.blocks.6.text': 'Nastavljamo kroz pašne livade, gdje se otvaraju pogledi na Kamniško-Savinjske Alpe i Julijske Alpe s Triglavom.',
  'story.blocks.6.terrain': 'Pašne livade, panoramski pogledi',
  'story.blocks.7.title': 'Sedlo — križanje s Grmadom',
  'story.blocks.7.text': 'Na Sedlu se staza križa s rutom prema Grmadi i spaja sa stazama iz Tacna, Šmartnog i Vikrča. Odavde možete odabrati lakšu makadamsku stazu ili užu, kamenitiju stazu pokraj kapelice sv. Sobote.',
  'story.blocks.7.terrain': 'Sedlo, križanje Grmada–Šmarna gora, dvije opcije',
  'story.blocks.8.title': 'Vrh — izbor staze',
  'story.blocks.8.text': 'Preporučuje se uspon zahtjevnijom stazom i spust blažom. Tako doživljavate obje strane Šmarne gore i uživate u potpunom iskustvu.',
  'story.blocks.8.terrain': 'Dvije staze, uspon i spust',

  'highlight.title': 'Jedna od najugodnijih staza na Šmarnoj gori',
  'highlight.text1': 'Ovo je također jedna od najugodnijih staza na Šmarnoj gori — nikad izložena, bez većih strmina i ugodna za hodanje i nakon kiše kada su mnoge druge staze blatne.',
  'highlight.text2': 'Prvi dio je vrlo raznolik i stoga iznimno popularan među planinarima, trkačima i obiteljima.',

  'viewpoint.badge': 'Panorama',
  'viewpoint.title': 'POGLEDI S VRHA',
  'viewpoint.desc': 'Na vrhu Šmarne gore, za vedrih dana odvojite vrijeme za uživanje u veličanstvenim pogledima na Ljubljanu, rijeku Savu, okolne brežuljke i Alpe. Vrh sa slikovitom crkvom nudi jednu od najljepših panorama u središnjoj Sloveniji.',

  'gallery.badge': 'Galerija',
  'gallery.title': 'Šmarna gora kroz objektiv',
  'gallery.subtitle': 'Trenuci koji oživljavaju duh planine — svaka fotografija priča svoju priču',
  'gallery.enlarge': 'Povećaj',
  'gallery.close': 'Zatvori pregled',
  'gallery.prev': 'Prethodna slika',
  'gallery.next': 'Sljedeća slika',
  'gallery.open': 'Otvori sliku',

  'weather.badge': 'Vrijeme uživo',
  'weather.title': 'VRIJEME NA ŠMARNOJ GORI',
  'weather.loading': 'Osvježavam...',
  'weather.updated': 'Zadnje ažuriranje',
  'weather.current': 'Trenutno',
  'weather.feels_like': 'Osjećaj',
  'weather.wind': 'Vjetar',
  'weather.humidity': 'Vlažnost',
  'weather.visibility': 'Vidljivost',
  'weather.cloud_cover': 'Naoblaka',
  'weather.uv_index': 'UV indeks',
  'weather.rain': 'Kiša',
  'weather.hiking_score': 'Ocjena za planinarenje',
  'weather.out_of': 'od 100 bodova',
  'weather.trail_safety': 'Sigurnost staze',
  'weather.safety_optimal': 'Sigurni uvjeti',
  'weather.safety_caution': 'Potreban oprez',
  'weather.safety_warning': 'Otežani uvjeti',
  'weather.safety_danger': 'Opasni uvjeti',
  'weather.no_alerts': 'Nema posebnih upozorenja',
  'weather.best_time': 'Najbolje vrijeme za planinarenje',
  'weather.next_hours': 'Sljedeći sati',
  'weather.seven_day': '7-dnevna prognoza',
  'weather.disclaimer': 'Podaci su informativnog karaktera. Prije planinarenja uvijek provjerite službenu vremensku prognozu. Izvor: Open-Meteo API.',
  'weather.error_load': 'Nije moguće učitati vremenske podatke',
  'weather.error_stale': 'Prikazujem posljednje spremljene podatke',
  'weather.smarna_elevation': 'Šmarna gora, 669m',

  'safety.badge': 'Važno',
  'safety.title': 'SIGURNOST NA STAZI',
  'safety.slippery_title': 'Skliska podloga',
  'safety.slippery_desc': 'Nakon kiše, korijenje i stijene su iznimno skliski. Nosite planinarske cipele s dobrim prianjanjem. Izbjegavajte prečace preko mokrog terena.',
  'safety.winter_title': 'Zimski uvjeti',
  'safety.winter_desc': 'Zimi staze mogu biti zaleđene. Obavezna je zimska oprema: dereze, planinarski štapovi. Provjerite vrijeme prije polaska.',
  'safety.sunset_title': 'Izlazak / zalazak sunca',
  'safety.sunset_desc': 'Ako krećete na izlazak ili zalazak sunca, obavezno ponesite čeonu svjetiljku. Uvijek recite nekome kamo idete.',
  'safety.emergency_title': 'Hitna pomoć',
  'safety.emergency_desc': 'U hitnim slučajevima nazovite 112. Aplikacija Gorske službe spašavanja omogućuje brzo lociranje. Spremite broj prije planinarenja.',
  'safety.warning_title': 'UPOZORENJE',
  'safety.warning_text': 'Informacije na ovoj stranici su informativnog karaktera. Planinarenje se poduzima na vlastitu odgovornost. Prije svakog planinarenja provjerite vremenske uvjete, osigurajte odgovarajuću opremu i procijenite svoju fizičku spremnost. STEZA ne preuzima odgovornost za moguće ozljede ili nezgode.',

  'facebook.badge': 'Zajednica',
  'facebook.title': 'PRIDRUŽITE NAM SE',
  'facebook.desc': 'Pratite STEZA.SI na Facebooku za najnovije informacije, događaje i fotografije',
  'facebook.label': 'Facebook zajednica',

  'webcam.badge': 'Uživo',
  'webcam.title': 'WEB KAMERA ŠMARNE GORE',
  'webcam.desc': 'Pogled uživo s vrha Šmarne gore — uskoro dostupno',
  'webcam.coming_soon': 'Web kamera uskoro dostupna',
  'webcam.preparing': 'Pripremamo prijenos uživo s vrha Šmarne gore. Hvala na strpljenju.',
  'webcam.status': 'U pripremi',

  'media.badge': 'Mediji',
  'media.title': 'GALERIJA & VIDEO',
  'media.desc': 'Kinematografske snimke i fotografije Šmarne gore — uskoro dostupno',
  'media.drone': 'DRONE VIDEO U PRIPREMI',
  'media.drone_desc': 'Kinematografska snimka Staze Peske',
  'media.views': 'Pogledi',
  'media.trail': 'Staza',
  'media.history': 'Povijest',

  'footer.desc': 'Staza Peske — Šmarna gora. Turističko društvo STEZA. Premium planinarsko iskustvo s profesionalnim informacijama o stazama, vremenu i sigurnosti.',
  'footer.newsletter_title': 'Primajte novosti o stazama',
  'footer.newsletter_success': 'Hvala! Prijavljeni ste na STEZA novosti.',
  'footer.newsletter_placeholder': 'Unesite svoj e-mail',
  'footer.newsletter_btn': 'Prijavi se',
  'footer.trails': 'Staze',
  'footer.platform': 'Platforma',
  'footer.legal': 'Pravno',
  'footer.pot_peske': 'Staza Peske',
  'footer.pot_korenine': 'Staza korijenja',
  'footer.mazijeva': 'Mazijeva staza',
  'footer.romarska': 'Hodočasnička staza',
  'footer.plezalna': 'Penjačka staza',
  'footer.izhodisca': 'Polazišta',
  'footer.galerija': 'Galerija',
  'footer.vreme': 'Vrijeme',
  'footer.o_stezi': 'O STEZI',
  'footer.kontakt': 'Kontakt',
  'footer.privacy': 'Pravila privatnosti',
  'footer.cookies': 'Kolačići',
  'footer.disclaimer': 'Odricanje odgovornosti',
  'footer.safety_notice': 'Sigurnosna obavijest',
  'footer.copyright': '© 2026 STEZA.SI — Turističko društvo STEZA, Šmarna gora',
  'footer.disclaimer_text': 'Važna napomena: Informacije na ovoj stranici su informativnog karaktera. Planinarenje i aktivnosti u prirodi poduzimaju se na vlastitu odgovornost. Prije posjeta provjerite vremenske uvjete, odgovarajuću opremu i stanje staza.',
  'footer.facebook_label': 'STEZA na Facebooku',
  'footer.instagram_label': 'STEZA na Instagramu',

  'about.hero_title': 'O STEZI',
  'about.hero_subtitle': 'Premium planinarska platforma, stvorena s ljubavlju prema Šmarnoj gori.',
  'about.story_badge': 'Naša priča',
  'about.story_title': 'Najljepša staza na Šmarnu goru',
  'about.story_p1': 'STEZA je nastala iz jednostavne ideje: planinarenje na Šmarnu goru može biti više od rekreacije — može biti doživljaj. Stvorili smo platformu koja spaja profesionalne planinarske informacije s vrhunskom estetikom i modernom tehnologijom.',
  'about.story_p2': 'Mi smo tim planinara, fotografa i dizajnera koji vjeruju da svaka planina zaslužuje svoju premium prezentaciju. Šmarna gora nije samo brežuljak — ona je simbol Ljubljane, hodočasnički cilj, prirodni biser i sportski poligon u jednom.',
  'about.story_p3': 'STEZA nije turistički portal. Nije blog. To je premium kinematografska planinarska platforma za sve koji žele otkriti Šmarnu goru na drugačiji način.',
  'about.elevation_label': 'Šmarna gora',
  'about.elevation': '669 m n. v.',
  'about.how_title': 'Kako je nastala STEZA',
  'about.how_p1': 'Priča je počela na vrhu Šmarne gore. Stajali smo na vidikovcu, gledali prema Alpama i pitali se: zašto tako prekrasan brežuljak nema modernu, preglednu i lijepu internetsku prezentaciju? Sve što smo našli bili su razbacani postovi na forumima, zastarjeli blogovi i nekvalitetne fotografije. Tada smo odlučili — stvorit ćemo nešto drugačije.',
  'about.how_p2': 'Sljedećih šest mjeseci proveli smo na terenu. Prohodali smo svaku stazu — od najlakše do najzahtjevnije. Fotografirali smo izlaske sunca, kišne šume, snježne vrhove i zlatne zalaske. Razgovarali smo s lokalnim vodičima, ugostiteljima, iskusnim planinarima i posjetiteljima prvi put. Htjeli smo razumjeti Šmarnu goru iz svakog kuta.',
  'about.how_p3': 'STEZA nije samo web stranica. To je vizualni dnevnik naše ljubavi prema ovoj planini. Svaka fotografija je profesionalno snimljena, svaka staza osobno prohodana, svaki podatak provjeren. Vjerujemo da Šmarna gora — kao jedna od najposjećenijih planinarskih destinacija u Sloveniji — zaslužuje prezentaciju svjetske klase.',
  'about.how_p4': 'Inspiraciju za dizajn crpili smo iz premium outdoor brendova poput Patagonije, The North Facea i National Geographic Travela. Htjeli smo stvoriti platformu koja diše avanturu, a istovremeno ostaje minimalistička, čista i profesionalna.',
  'about.how_p5': 'Danas STEZA pokriva četiri glavne staze na Šmarnu goru, vremenske podatke uživo, GPS navigaciju, sigurnosne smjernice i bogatu galeriju. Ali ovo je tek početak. Naša vizija je postati najbolja planinarska platforma u Sloveniji — a Šmarna gora je naš prvi, najdraži projekt.',
  'about.gora_badge': 'Upoznajte planinu',
  'about.gora_title': 'Šmarna gora — srce naše priče',
  'about.gora_subtitle': '669 metara koji povezuju generacije',
  'about.gora_p1': 'Šmarna gora (669 m) najpopularniji je izletnički vrh u središnjoj Sloveniji. Nalazi se samo 10 kilometara sjeverozapadno od Ljubljane, ali unatoč blizini grada nudi autentičan dodir s prirodom, bogatu povijest i zadivljujuće poglede.',
  'about.gora_p2': 'Radi se o osamljeniku — brežuljku koji geološki ne pripada nijednom većem gorju, već se samostalno uzdiže iznad Ljubljanske kotline. Sastavljen je od vapnenca i dolomita, a njegove južne padine poznate su po toploljubivim biljnim vrstama.',
  'about.gora_p3': 'Kroz stoljeća, Šmarna gora bila je sve: prapovijesno naselje, strateška točka s dvorcem Šumberk, hodočasnički cilj, popularno izletište građana, a danas je neizostavan dio sportske i kulturne identitete Ljubljane.',
  'about.history_title': 'Povijest zapisana u kamenu',
  'about.history_bronze_date': '1500 pr. Kr.',
  'about.history_bronze_title': 'Brončano doba',
  'about.history_bronze_text': 'Arheološki nalazi na vrhu svjedoče o prapovijesnom naselju. Keramika, oruđe i ostaci nastambi ukazuju na stalnu naseljenost tijekom brončanog doba.',
  'about.history_castle_date': '12.–13. st.',
  'about.history_castle_title': 'Dvorac Šumberk',
  'about.history_castle_text': 'Na vrhu je stajao srednjovjekovni dvorac Šumberk (Schönberg). Danas su od njega ostali samo skromni arheološki tragovi i legende o vitezovima.',
  'about.history_church_date': '1711.',
  'about.history_church_title': 'Crkva Majke Božje',
  'about.history_church_text': 'Izgrađena je barokna crkva na mjestu starije gotičke crkve iz 14. stoljeća. Postaje središnje hodočasničko odredište središnje Slovenije.',
  'about.history_modern_date': '19. st.–danas',
  'about.history_modern_title': 'Planinarska točka',
  'about.history_modern_text': 'S razvojem planinarstva postaje najpopularnije izletište Ljubljančana. Taj status drži i danas s više od 500.000 posjetitelja godišnje.',
  'about.nature_title': 'Priroda koja nadahnjuje',
  'about.nature_p1': 'Južne padine Šmarne gore su botanički raj. Toplu mikroklimu koriste biljke koje inače nalazimo znatno južnije: crni kukurijek cvate već u veljači, slijede ga mirisna perunika, obična sasa i jesenski mrazovac.',
  'about.nature_p2': 'Šume su mješovite — prevladavaju bukva, hrast i smreka, a na vrhu raste veličanstveni kesten. Životinjski svijet uključuje srne, lisice, divlje svinje, jazavce, vjeverice i puhove.',
  'about.nature_p3': 'Poticemo odgovorno planinarenje — ne ostavljajte tragove, ne berite biljke, ne uznemiravajte životinje i odnesite smeće sa sobom u dolinu.',
  'about.legends_title': 'Legende koje žive',
  'about.legend_bell_title': 'Zvono želja',
  'about.legend_bell_text': 'Najpoznatija legenda Šmarne gore. Ako triput pozvoniš — prvi put za zdravlje, drugi put za sreću i treći put za ljubav — i pri svakom zvonjenju nešto poželiš, želja će ti se ostvariti.',
  'about.legend_castle_title': 'Dvorac Šumberk i blago',
  'about.legend_castle_text': 'Legenda kaže da su vitezovi dvorca Šumberk prije odlaska u križarske ratove zakopali zlatno blago negdje na padinama Šmarne gore. Nitko ga nikada nije pronašao.',
  'about.legend_mary_title': 'Marijino ukazanje',
  'about.legend_mary_text': 'Prema narodnoj predaji, na vrhu brežuljka ukazala se Djevica Marija, po čemu je gora dobila ime. Ta je predaja dovela do izgradnje crkve i hodočasničke tradicije koja traje više od 300 godina.',
  'about.stats_title': 'STEZA u brojkama',
  'about.values_title': 'Naše vrijednosti',
  'about.values.professionalism': 'Profesionalnost',
  'about.values.professionalism_text': 'Sve informacije su pažljivo provjerene i redovito ažurirane. Surađujemo s lokalnim vodičima i Gorskom službom spašavanja.',
  'about.values.aesthetics': 'Estetika',
  'about.values.aesthetics_text': 'Vjerujemo da su lijepi vizualni elementi ključni za inspiraciju. Svaka fotografija na stranici je profesionalno snimljena i kurirana.',
  'about.values.safety': 'Sigurnost',
  'about.values.safety_text': 'Sigurnost je na prvom mjestu. Svaka staza uključuje detaljna upozorenja, preporučenu opremu i sigurnosne smjernice.',
  'about.values.passion': 'Strast',
  'about.values.passion_text': 'STEZA je projekt iz strasti. Svaki član tima je planinar koji osobno poznaje svaku stazu na Šmarnoj gori.',
  'about.values.sustainability': 'Održivost',
  'about.values.sustainability_text': 'Poticemo odgovorno planinarenje. Ne ostavljajte tragove, poštujte prirodu i divlje životinje, odnesite smeće sa sobom.',
  'about.values.community': 'Zajednica',
  'about.values.community_text': 'Gradimo zajednicu planinara koji dijele iskustva i pomažu jedni drugima u otkrivanju Šmarne gore.',
  'about.cta_title': 'Pridružite se STEZI',
  'about.cta_subtitle': 'Svaka staza ima priču. Otkrijte je s nama.',
  'about.cta_explore': 'Istraži staze',
  'about.cta_contact': 'Kontaktirajte nas',

  'contact.hero_title': 'Kontakt',
  'contact.hero_subtitle': 'Imate pitanje, prijedlog ili želite surađivati? Pišite nam ili nazovite.',
  'contact.write_us': 'Pišite nam',
  'contact.email_label': 'E-pošta',
  'contact.phone_label': 'Telefon',
  'contact.location_label': 'Lokacija',
  'contact.location_value': 'Šmarna gora, 1211 Ljubljana-Šmartno, Slovenija',
  'contact.follow_us': 'Pratite nas',
  'contact.success_title': 'Hvala na poruci!',
  'contact.success_text': 'Odgovorit ćemo vam u najkraćem mogućem roku.',
  'contact.name_label': 'Ime',
  'contact.name_placeholder': 'Vaše ime',
  'contact.email_placeholder': 'vasa@posta.hr',
  'contact.message_label': 'Poruka',
  'contact.message_placeholder': 'Vaša poruka (najviše 500 znakova)',
  'contact.submit': 'Pošalji poruku',
  'contact.error_fields': 'Molimo ispunite sva polja.',
  'contact.error_length': 'Poruka je preduga. Najviše 500 znakova.',
  'contact.error_general': 'Došlo je do pogreške. Pokušajte ponovno.',

  'routes.hero_title': 'Staze',
  'routes.hero_subtitle': 'Pet jedinstvenih staza do vrha Šmarne gore. Od lagane Staze Peske do zahtjevnih penjačkih ruta — odaberite svoju STEZU.',
  'routes.explore': 'Istraži stazu',
  'routes.compare_title': 'Usporedba staza',
  'routes.table_pot': 'Staza',
  'routes.table_tezavnost': 'Težina',
  'routes.table_trajanje': 'Trajanje',
  'routes.table_visinska': 'Visinska',
  'routes.table_dolzina': 'Duljina',
  'routes.table_tip': 'Tip',
  'routes.cta_title': 'Spremni za svoju STEZU?',
  'routes.cta_subtitle': 'Odaberite stazu koja vam najviše odgovara i otkrijte Šmarnu goru na način koji ćete pamtiti.',
  'routes.cta_find': 'Pronađi polazište',
  'routes.cta_weather': 'Provjeri vrijeme',
  'routes.difficulty_easy': 'Lagano',
  'routes.difficulty_moderate': 'Umjereno',
  'routes.difficulty_hard': 'Zahtjevno',

  'gallery_page.badge': 'Fotografska zbirka',
  'gallery_page.title': 'Galerija',
  'gallery_page.subtitle': 'Zbirka fotografija sa Šmarne gore — staze, pogledi i trenuci koje dijelimo.',
  'gallery_page.section_trail_title': 'Put do vrha',
  'gallery_page.section_trail_subtitle': 'Planinarske staze kroz šumu i prirodu tijekom uspona',
  'gallery_page.section_summit_title': 'Vrh',
  'gallery_page.section_summit_subtitle': 'Pogledi, panorama i trenuci na vrhu Šmarne gore',
  'gallery_page.section_parking_title': 'Parkiralište',
  'gallery_page.section_parking_subtitle': 'Pristup polazištu i parkiranje kroz sva godišnja doba',
  'gallery_page.empty_title': 'Sekcija {title} je spremna. Dodajte slike i pojavit će se ovdje.',
  'gallery_page.empty_subtitle': 'Sekcija je spremna.',
  'gallery_page.close': 'Zatvori galeriju',
  'gallery_page.prev': 'Prethodna slika',
  'gallery_page.next': 'Sljedeća slika',
  'gallery_page.open': 'Pogledaj sliku',
  'gallery_page.cta_title': 'Snimite vlastitu fotografiju',
  'gallery_page.cta_subtitle': 'Najljepše fotografije nastaju na vrhu. Podijelite svoje najbolje snimke s oznakom #STEZA.',
  'gallery_page.cta_btn': 'Pronađi svoju stazu',

  'legal.not_found': 'Stranica nije pronađena',
  'legal.back_home': '← Natrag na početnu',
  'legal.updated': 'Zadnje ažuriranje',
  'legal.copyright': '© 2026 STEZA.SI — Sva prava pridržana. Kontakt: info@steza.si',

  'notfound.title': 'Ova stranica još nije stvorena',
  'notfound.subtitle': 'Recite mi više o ovoj stranici, kako bih je mogao stvoriti',
  'notfound.back_home': 'Natrag na početnu',

  'lang.sl': 'Slovenščina',
  'lang.en': 'English',
  'lang.de': 'Deutsch',
  'lang.it': 'Italiano',
  'lang.hr': 'Hrvatski',
  'lang.es': 'Español',
  'lang.ru': 'Русский',

  'seo.home_title': 'Staza Peske — Šmarna gora | STEZA — Premium planinarska platforma',
  'seo.home_desc': 'Staza Peske jedna je od najljepših ruta na Šmarnu goru. Premium planinarsko iskustvo s profesionalnim informacijama o stazama, vremenu, sigurnosti i vidikovcima. Turističko društvo STEZA.',
  'seo.home_keywords': 'Staza Peske, Šmarna gora, planinarenje Šmarna gora, planinarenje Slovenija, staze Šmarna gora, planinarenje Ljubljana, alpinizam Slovenija',
  'seo.og_title': 'Staza Peske — Šmarna gora | STEZA',
  'seo.og_desc': 'Premium planinarska platforma za Šmarnu goru. Otkrijte Stazu Peske — jednu od najljepših i najugodnijih staza na Šmarnu goru.',
  'seo.schema_desc': 'Staza Peske jedna je od najljepših ruta na Šmarnu goru. Turističko društvo STEZA — premium planinarska platforma za Šmarnu goru.',
};